import { createReducer, updateDeepState } from '../handlers'
import types from './types'

const initialState = {
  brands: [],
  delegations: [],
  isPending: true
}

const update = (state, action) => {
  const { centers } = action

  let isPending = true
  if (centers?.brands?.length && centers?.delegations?.length) {
    isPending = false
  }

  return updateDeepState(state, { ...centers, isPending })
}

export default createReducer(initialState, {
  [types.update]: update,
})